export default "__VITE_ASSET__347b488c__"